import React from "react";
import { ArrowUpRight, ArrowDown, Minus } from "@phosphor-icons/react";
import { relativeTime } from "../lib/time";

const tagFor = (s) => {
  if (s === "positive") return { c: "#34C759", icon: ArrowUpRight, label: "POS" };
  if (s === "negative") return { c: "#FF3B30", icon: ArrowDown, label: "NEG" };
  return { c: "#A1A1AA", icon: Minus, label: "NEU" };
};

export default function NewsFeed({ items = [], summary }) {
  return (
    <div className="bg-surface border border-white/10 flex flex-col h-full" data-testid="news-feed">
      <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
        <h3 className="heading text-lg font-semibold">News Sentiment</h3>
        {summary && (
          <span className="overline">
            {summary.positive}↑ {summary.neutral}= {summary.negative}↓
          </span>
        )}
      </div>
      <div className="overflow-y-auto max-h-[420px]">
        {items.length === 0 && <div className="overline p-6 text-center">no headlines</div>}
        {items.map((h, i) => {
          const t = tagFor(h.sentiment);
          const Icon = t.icon;
          return (
            <a
              key={i}
              href={h.link}
              target="_blank"
              rel="noopener noreferrer"
              className="block px-5 py-3 border-b border-white/5 hover:bg-white/[0.03] transition-colors duration-150"
              data-testid={`news-item-${i}`}
            >
              <div className="flex items-start gap-3">
                <div className="flex flex-col items-center mt-0.5" style={{ color: t.c, minWidth: 28 }}>
                  <Icon size={16} weight="bold" />
                  <span className="mono text-[9px] mt-0.5">{t.label}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm leading-snug">{h.title}</div>
                  <div className="mono text-[10px] text-white/40 mt-1 flex items-center gap-2">
                    <span className="truncate">{h.source || "news"}</span>
                    {h.published_iso && (
                      <>
                        <span className="text-white/20">·</span>
                        <span className="shrink-0 text-white/55">{relativeTime(h.published_iso)}</span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
}
